export default {
  name: 'dealThousandsPlugin',

  // 插件是否自动安装
  autoInstall: true,

  install (Vue, options) {
    Vue.prototype.$dealThousands = function (value, precision) {
      /**
       * 根据precision进行数据转化
       *   - precision >= 0 时，转换为对应精度的字符串
       *   - precision === -1 时，转换为不带精度的字符串
       * @param {*} _value
       * @param {*} _precision
       * @returns
       */
      function parsePrecision (_value = 0, _precision = 2) {
        if (_precision >= 0) {
          return _value.toFixed(_precision)
        } else {
          return _value.toString();
        }
      }

      if (value === undefined || value === null || value === '') {
        return ''
      }

      if (value === 0) {
        return parsePrecision(0, precision);
      }

      let num = '';
      value += ''; // 转化成字符串

      // 若需要其他小数精度，可将2改成变量
      value = parsePrecision(parseFloat(value.replace(/,/g, '')), precision);
      if (value.indexOf('.') === -1) {
        num = value.replace(/(\d{1,3})(?=(?:\d{3})+$)/g, '$1,');
      } else {
        num = value.replace(/(\d)(?=(?:\d{3})+\.)/g, '$1,');
      }

      if (num === 'NaN') {
        num = parsePrecision(0, precision);
      }

      return num;
    };
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/dealThousands/index.js